module.exports = __webpack_public_path__ + "static/media/IMG_1865.1e0241bb.JPG";